import { OTHER, LEAVING_FOR_COMPETITOR } from "../../enums/inactivationReasonTypes";

export const plannedInactiveValidationRules = {
    lastActiveDate: {
        isRequiredTrim: {
            value: true,
        },
    },
    inactivationReasonType: {
        isRequiredTrim: {
            value: true,
        },
    },
    inactivationReasonComplement: {
        isRequiredTrimIfFieldHasValue: {
            value: {
                field: "inactivationReasonType",
                expectedValues: [
                    OTHER.value,
                    LEAVING_FOR_COMPETITOR.value,
                ],
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/change-status/PlannedInactiveValidationRules.js